import type { UseCards } from './CardsSandbox';
import { useCardContext } from './CardsContext';

export function useCards(): ReturnType<UseCards> {
    return useCardContext().value.useCards();
}
